import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref } from 'vue';
import ComSearchButton from './buttons/ComSearchButton.vue';
import ComNimikeCascader from './ComNimikeCascader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ComCascaderSearch',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const model = _useModel<[number, number, number]>(__props, "modelValue")
const show = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createBlock(_component_el_space, null, {
    default: _withCtx(() => [
      _createVNode(ComSearchButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = !show.value))
      }),
      (show.value)
        ? (_openBlock(), _createBlock(ComNimikeCascader, {
            key: 0,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})